// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"471":"1ea8c896","501":"d93a4b8a","573":"738fa8d4"}[chunkId] + ".chunk.css");